import { render, staticRenderFns } from "./idnex.vue?vue&type=template&id=60361afb&scoped=true"
import script from "./idnex.vue?vue&type=script&lang=js"
export * from "./idnex.vue?vue&type=script&lang=js"
import style0 from "./idnex.vue?vue&type=style&index=0&id=60361afb&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60361afb",
  null
  
)

export default component.exports